// selling plan management
(() => {
  if (!window.location.pathname.includes('/products')) return;
  
  const checkSkioPlanPicker = () => {
    const hostElements = document.querySelectorAll('*');
    for (const el of hostElements) {
      if (el.shadowRoot) {
        const skioFieldset = el.shadowRoot.querySelector('fieldset.skio-plan-picker');
        if (skioFieldset) {
          window.Abra.useSellingPlanPriceOnProductBlock = true;
          window.Abra.render();
          return true;
        }
      }
    }
    return false;
  };

  const observer = new MutationObserver(() => {
    if (checkSkioPlanPicker()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  checkSkioPlanPicker();
})();

